document.addEventListener("DOMContentLoaded", function() {
	var video1 = document.getElementById("ban_video");
	if (video1) {
		video1.pause();
		video1.currentTime = 0;
	}

	document.querySelectorAll(".play-bt").forEach(function(element) {
		element.addEventListener("click", function() {
			document.querySelectorAll(".play-bt").forEach(function(bt) {
				bt.style.display = "none";
			});
			document.querySelectorAll(".pause-bt").forEach(function(bt) {
				bt.style.display = "block";
			});

			var ban_video = document.getElementById("ban_video");
			var stopButton = document.querySelector(".stop-bt");
			if (ban_video && stopButton && stopButton.classList.contains("active")) {
				ban_video.currentTime = 0;
			}
			if (ban_video) {
				ban_video.play();
			}
		});
	});

	document.querySelectorAll(".pause-bt").forEach(function(element) {
		element.addEventListener("click", function() {
			document.querySelectorAll(".play-bt").forEach(function(bt) {
				bt.style.display = "block";
			});
			document.querySelectorAll(".pause-bt").forEach(function(bt) {
				bt.style.display = "none";
				bt.classList.add("active");
			});
			document.querySelectorAll(".stop-bt").forEach(function(bt) {
				bt.classList.remove("active");
			});

			var ban_video = document.getElementById("ban_video");
			if (ban_video) {
				ban_video.pause();
			}
		});
	});

	document.querySelectorAll(".stop-bt").forEach(function(element) {
		element.addEventListener("click", function() {
			document.querySelectorAll(".play-bt").forEach(function(bt) {
				bt.style.display = "block";
			});
			document.querySelectorAll(".pause-bt").forEach(function(bt) {
				bt.style.display = "none";
				bt.classList.remove("active");
			});
			document.querySelectorAll(".stop-bt").forEach(function(bt) {
				bt.classList.add("active");
			});

			var ban_video = document.getElementById("ban_video");
			if (ban_video) {
				ban_video.pause();
			}
		});
	});

	if (window.innerWidth < 961) {
		document.querySelectorAll(".play-bt").forEach(function(bt) {
			bt.style.display = "block";
		});
		document.querySelectorAll(".pause-bt").forEach(function(bt) {
			bt.style.display = "block";
			bt.classList.remove("active");
		});
		document.querySelectorAll(".stop-bt").forEach(function(bt) {
			bt.classList.add("active");
		});
	} else {
		document.querySelectorAll(".play-bt").forEach(function(bt) {
			bt.style.display = "block";
		});
		document.querySelectorAll(".pause-bt").forEach(function(bt) {
			bt.style.display = "none";
		});
	}
});
